import { axiosInstance } from 'network/apis';

  export const updateModeratorDetails = async (payload) => {
    return axiosInstance.put(`/moderator/moderator-id/${payload.moderatorId}`,{moderatorBuffer: payload.value, updateAvailabilities: 1 } ,{ handlerEnabled: true })
  };

export default {
    updateModeratorDetails
}

